export default "__VITE_ASSET__DIyaTNz4__"